import PropTypes from "prop-types";

import ServiceWrapper from "../utils/ServiceWrapper";
import {
    BUS_PASS_APPLICATION_BY_STUDENT_NUMBER,
    CHECKIN_WINDOW,
    CHECKIN_WINDOW_DETAIL,
    CHECKIN_WINDOW_PARENT,
    CUSTOM_ATTRIBUTE_GET,
    ECHECKIN_BUS_PASS_APPLICATIONS_CREATE,
    ELECTRONIC_SIGNATURE_BY_MAPID_AND_TYPE,
    GUARDIAN_STUDENT_MAP,
    HIST_BUS_PASS_APPLICATION_BY_STUDENT_NUMBER,
    SELECTED_VALUE
} from "../const/EcheckinConst";

/**
 * Data Access for the Echeckin Service
 * @name EcheckinDao
 * @param {*} props
 */
const EcheckinDao = (props) => {
    const { action, dto, locKey, mapId, params, schoolYearKey, studentNumber, token, type, username } = props;
    const bearer = `Bearer ${token}`;
    const options = {
        headers: {
            Authorization: bearer
        },
        withCredentials: true
    };
    switch (action) {
        case "busPassApplicationCreate":
            options.method = "POST";
            options.data = dto;
            options.url = ECHECKIN_BUS_PASS_APPLICATIONS_CREATE;
            break;
        case "busPassApplicationsByStudentNumber":
            options.method = "GET";
            options.url = `${BUS_PASS_APPLICATION_BY_STUDENT_NUMBER}/${studentNumber}/${schoolYearKey}/index.json`;
            break;
        case "histBusPassApplicationsByStudentNumber":
            options.method = "GET";
            options.url = `${HIST_BUS_PASS_APPLICATION_BY_STUDENT_NUMBER}/${studentNumber}/index.json`;
            break;
        case "checkinWindowParentCheckin":
            options.method = "GET";
            if (params) {
                options.params = params;
            }
            options.url = `${CHECKIN_WINDOW_PARENT}/${schoolYearKey}/${locKey}/detail.json`;
            break;
        case "checkinWindowBySchoolYearAndType":
            options.method = "GET";
            options.params = params;
            options.url = `${CHECKIN_WINDOW}/${schoolYearKey}/index.json`;
            break;
        case "checkinWindowTransportation":
            options.method = "GET";
            options.params = params;
            options.url = `${CHECKIN_WINDOW_DETAIL}/${schoolYearKey}/TRANSPORTATION/detail.json`;
            break;
        case "customStudentAttributeRead":
            options.params = params;
            options.method = "GET";
            options.url = `${CUSTOM_ATTRIBUTE_GET}/${studentNumber}/detail.json`;
            break;
        case "eSignatureRead":
            options.method = "GET";
            options.url = `${ELECTRONIC_SIGNATURE_BY_MAPID_AND_TYPE}/${mapId}/${type}/detail.json`;
            break;
        case "guardianStudentMapByStudentNumberRead":
            options.method = "GET";
            options.params = params;
            options.url = `${GUARDIAN_STUDENT_MAP}/${studentNumber}/${username}/detail.json`;
            break;
        case "guardianStudentMapRead":
            options.method = "GET";
            options.url = `${GUARDIAN_STUDENT_MAP}/${mapId}/detail.json`;
            break;
        case "selectedValuesRead":
            options.method = "GET";
            options.params = params;
            options.url = SELECTED_VALUE;
            break;
        case "selectedValue": // BE java service will determine this case
            options.method = "POST";
            options.data = dto; // must be an ARRAY of DTOs !!
            options.url = SELECTED_VALUE;
            break;
        default:
            return null;
    }

    return ServiceWrapper.serviceCall({
        options,
        ...props
    });
};

EcheckinDao.propTypes = {
    action: PropTypes.string.isRequired,
    dto: PropTypes.oneOfType([PropTypes.object]),
    locKey: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    mapId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    params: PropTypes.oneOfType([PropTypes.object]),
    schoolYearKey: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    studentNumber: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    token: PropTypes.string.isRequired,
    type: PropTypes.string,
    username: PropTypes.string
};

EcheckinDao.defaultProps = {
    dto: null,
    locKey: null,
    mapId: null,
    params: null,
    schoolYearKey: null,
    studentNumber: null,
    type: null,
    username: null
};

export default EcheckinDao;
